import React, { memo } from 'react'
import { Drawer } from 'transfix-ui/core'
import { makeStyles } from 'transfix-ui/core/styles'

const useStyles = makeStyles({
  paper: {
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
    boxShadow: '0px 0px 24px rgba(0, 0, 0, 0.15)',
    border: '1px solid #A9B2BD',
    boxSizing: 'border-box',
  },
})

export interface IBottomDrawerProps {
  drawerHeight?: number
  isOpen: boolean
  children: React.ReactNode
}

export const BottomDrawer = memo<IBottomDrawerProps>(({ children, isOpen }) => {
  const classes = useStyles()
  return (
    <Drawer variant='persistent' open={isOpen} anchor='bottom' classes={{ paper: classes.paper }}>
      <div className='pa4'>{children}</div>
    </Drawer>
  )
})
